import Mustache from "mustache";

import editTemplate from "templates/elements/template/edit.mustache";
import showTemplate from "templates/elements/template/show.mustache";

export default class templateElement {
  constructor(options) {
    this.learnEditor = options.editor ? options.editor : null;

    this.editorEnabled = false;
    this.savedTitleText = "";
    this.savedDescriptionText = "";
    this.activeElementId;

    this.init();
  }

  init() {
    $(document).on(
      "click",
      ".add-build-template",
      this.appendTemplate.bind(this),
    );
    $(document).on(
      "click",
      ".build-template",
      this.editExistingButton.bind(this),
    );

    $(document).on(
      "click",
      ".editor-add-template-submit",
      this.saveButtonHandler.bind(this),
    );
    $(document).on(
      "click",
      ".editor-add-template-cancel",
      this.cancelButtonHandler.bind(this),
    );
    $(document).on(
      "click",
      ".editor-add-template-delete",
      this.deleteButtonHandler.bind(this),
    );
  }

  shouldShowButton() {
    return $('input[name="page_type"]').val() === "template";
  }

  addButtonTemplate() {
    return '<a class="add-build-template" href="#"><i class="fa fa-list-alt"></i>Template Area</a>';
  }

  appendTemplate(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $activeButtonBar = $(event.target).closest(
      ".button-bar, .bottom-button-bar",
    );
    var $templateEditor = Mustache.render(editTemplate, {});
    $activeButtonBar.replaceWith($templateEditor);

    this.learnEditor.enable_text_editor($("#template-description-editor"));
    this.learnEditor.center_in_view($templateEditor);

    this.learnEditor.editing();
  }

  editExistingButton(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $element = $(event.currentTarget);
    var title = $element.find(".title").html();
    var description = $element.find(".description").html();

    self.activeElementId = $element.attr("id");
    self.activePosition = $element.data("position");
    this.savedTitleText = title;
    this.savedDescriptionText = description;

    $element.replaceWith(
      $(
        Mustache.render(editTemplate, {
          title: title,
          description: description,
        }),
      ),
    );

    this.learnEditor.enable_text_editor($("#template-description-editor"));
    this.learnEditor.center_in_view($(".editor-add-template-wrapper"));

    this.learnEditor.editing();
  }

  templateEditorModified() {
    this.learnEditor.save_page("Before Template Modified");
  }

  saveButtonHandler(event) {
    event.preventDefault();

    let title = $(".editor-add-template-title").val();
    let description = $.trim(tinymce.activeEditor.getContent());
    this.learnEditor.disable_text_editor($(".build-textarea"));

    this.createTemplateElement(title, description);
    this.clearAttributes();
    this.templateEditorModified();
  }

  cancelButtonHandler(event) {
    event.preventDefault();

    this.learnEditor.disable_text_editor($(".build-textarea"));

    if (this.savedTitleText || this.savedDescriptionText) {
      this.createTemplateElement(
        this.savedTitleText,
        this.savedDescriptionText,
      );
      this.clearAttributes();
    } else {
      $(".editor-add-template-wrapper").remove();
    }

    this.learnEditor.finishEditing();
  }

  clearAttributes() {
    this.savedDescriptionText = "";
    this.savedTitleText = "";
    self.activeElementId = "";
    self.activePosition = "";
  }

  deleteButtonHandler(event) {
    event.preventDefault();

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.clearAttributes();
    this.learnEditor.disable_text_editor($(".build-textarea"));
    $(".editor-add-template-wrapper").remove();

    this.templateEditorModified();
  }

  createTemplateElement(title, description) {
    var $templateElement = $(
      Mustache.render(showTemplate, {
        title: title,
        description: description,
        id: self.activeElementId || "",
        position: self.activePosition || "",
      }),
    );

    $(".editor-add-template-wrapper").replaceWith($templateElement);
  }
}
